import { render, staticRenderFns } from "./popupReplyLike.vue?vue&type=template&id=85e354fa&scoped=true&"
import script from "./popupReplyLike.vue?vue&type=script&lang=js&"
export * from "./popupReplyLike.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popupReply.css?vue&type=style&index=0&id=85e354fa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e354fa",
  null
  
)

export default component.exports